





import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class App extends Vue {}
